import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import { publicHeight } from 'Cloud/ui/PublicHeight';
import { isReactMobilePublic } from 'reactApp/sections/MobilePublicPage/isReactMobilePublic';
import { Header } from 'reactApp/ui/Header/Header';

export default () => {
    const headerEl = document.querySelector('#portal-menu');

    const header = new BReactComponent({
        ReactComponent: Header,
        renderMode: 'replace',
        data: {
            mods: ['sticky'],
        },
    });

    const renderHeader = () => {
        if (!headerEl) {
            return;
        }

        header.renderTo(headerEl);
        publicHeight.updateContentHeight();
    };

    app.on('page:start', () => {
        if (isReactMobilePublic) {
            return;
        }
        renderHeader();
    });
};
